import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPreviousJobPartListResponse, IPreviousJobPartListsResponse } from "../models/Job";

export default function usePreviousJobPartList() {
  const { get } = useApiHelper();

  const previousPartList = useMutation(
    (vehicleId: string) => get<IPreviousJobPartListResponse>(`/job/vehicle/${vehicleId}/previous-part-list`)
  );

  const previousPartLists = useMutation(
    (vehicleId: string) => get<IPreviousJobPartListsResponse>(`/job/vehicle/${vehicleId}/previous-part-lists`)
  );

  return {
    previousPartList,
    previousPartLists,
  };
}
